import appConfig from '@/app.config.js'

export default class Background {

    constructor(options) {

        this.backgroundColor = options.color
        this.backgroundImage = options.image
        this.backgroundType = options.type
        this.backgroundImageBlur = options.blur
        this.backgroundImageDarken = options.darken
        this.navTextColor = options.navText
        this.useTheme = options.useTheme

        this.setBackground()
    }

    setBackground() {

        let bg = 'var(--background-image)'
        // let bg = `linear-gradient(180deg, ${this.backgroundColor}, ${appConfig.colors[this.backgroundColor]})`

        if (this.backgroundImage && this.backgroundType === 'image') {
            bg = `url(${this.backgroundImage}`
        }

        var themeColor = document.querySelectorAll('meta[name="theme-color"]');
        var metaThemecolorArr = Array.prototype.slice.call(themeColor);
        metaThemecolorArr.forEach(element => element.setAttribute("content", this.backgroundColor));

        document.documentElement.style.setProperty('--body-bg-image', bg)
        document.documentElement.style.setProperty('--mobile-footer-bg-color', appConfig.colors[this.backgroundColor])

        if (typeof this.backgroundImageBlur == 'undefined' && typeof this.backgroundImageDarken == 'undefined') {
            document.querySelector("#bg-backdrop").style['-webkit-filter'] = 'unset'
            document.querySelector("#bg-backdrop").style['filter'] = 'unset'
        } else {

            if (this.backgroundImage) {
                document.documentElement.style.setProperty('--bg-image-blur', 'blur(' + this.backgroundImageBlur + 'px)')
                document.documentElement.style.setProperty('--bg-image-brightness', 'brightness(' + (100 - this.backgroundImageDarken) + '%)')

                document.querySelector("#bg-backdrop").style['-webkit-filter'] = 'var(--bg-image-brightness) var(--bg-image-blur)'
                document.querySelector("#bg-backdrop").style['filter'] = 'var(--bg-image-brightness) var(--bg-image-blur)'
            }
        }

        document.documentElement.style.setProperty('--icon-color', this.navTextColor)
        document.documentElement.style.setProperty('--legacy-text-color', this.navTextColor)
        document.documentElement.style.setProperty('--nav-color', this.navTextColor)
    }
}
